import { ModalHeader } from "datastake-daf/dist/components";

export default function Header({
  t = (s) => s,
  activeKey,
  setActiveKey = () => { },
  tabsConfig = [],
}) {
  return (
    <ModalHeader
      title={t('Data Settings')}
      tabsConfig={{
        value: activeKey,
        onChange: (key) => setActiveKey(key),
        tabs: tabsConfig.map((tab, i) => ({
          value: tab.key,
          label: t(tab.label),
        })),
      }}
    />
  )
}
